class SubscriptionOptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onSelectChange = this.onSelectChange.bind(this);

    this.querySelector('[data-subscription-options-el="select"]').addEventListener('change', this.onSelectChange);
  }

  onSelectChange(event) {
    const dataElement = this.querySelector('[data-subscription-options-el="data"]');

    if (dataElement) {
      const data = JSON.parse(dataElement.textContent);
      const selectedValue = event.target.value;
      const result = data.sellingPlans.find(item => item.id === selectedValue);

      if (result) {

        console.log('Found selling plan:', result);

        result.priceAdjustments.forEach(adjustment => {
          if (adjustment.type === 'initial') {
            const regularEl = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-regular"]');
            const subscriptionEl = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions"]');
            const originalPriceElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-original-price"]');
            const priceElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-price"]');
            const sellingPlan = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-selling-plan"]');

            if (subscriptionEl) {
              subscriptionEl.setAttribute('aria-hidden', 'false');
              regularEl.setAttribute('aria-hidden', 'true');
            }

            if (priceElement) {
              priceElement.textContent = adjustment.discountedPrice;
            }

            if (originalPriceElement) {
              originalPriceElement.textContent = adjustment.originalPrice;
            }

            if (sellingPlan) {
              sellingPlan.setAttribute('value', result.id);
            }

          } else if (adjustment.type === 'recurring') {
            const regularEl = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-regular"]');
            const subscriptionEl = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions"]');
            const originalPriceElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-original-price"]');
            const recurringPriceElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-recurring-price"]');
            const sellingPlan = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-selling-plan"]');

            if (subscriptionEl) {
              subscriptionEl.setAttribute('aria-hidden', 'false');
              regularEl.setAttribute('aria-hidden', 'true');
            }

            if (originalPriceElement) {
              originalPriceElement.textContent = adjustment.originalPrice;
            }

            if (sellingPlan) {
              sellingPlan.setAttribute('value', result.id);
            }

            if (recurringPriceElement) {

              adjustment.sellingPlan.forEach(plan => {
                if (plan.name === 'Order Frequency and Unit') {
                  console.log('Found Order Frequency and Unit plan:', plan);

                  const intervalElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-recurring-item-details"]');
                  const intervalPriceElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-recurring-price"]');
                  const intervalLengthElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-recurring-interval"]');
                  const intervalPriceOptionsElement = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-has-recurring-options"]');

                  intervalElement.setAttribute('aria-hidden', 'false');
                  intervalPriceOptionsElement.setAttribute('aria-hidden', 'false');

                  intervalPriceElement.textContent = adjustment.recurringDiscountPrice;
                  intervalLengthElement.textContent = plan.value;
                }
              });
            }
          }
        });
      } else {
        const regularEl = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-regular"]');
        const subscriptionEl = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions"]');
        const sellingPlan = this.closest('.card__content').querySelector('[data-subscription-options-el="price-container-subscriptions-selling-plan"]');

        if (subscriptionEl) {
          subscriptionEl.setAttribute('aria-hidden', 'true');
          regularEl.setAttribute('aria-hidden', 'false');

          // empty the selling plan value
          if (sellingPlan) {
            sellingPlan.setAttribute('value', '');
          }
        }
      }
    }
  }
}

customElements.define('subscription-options', SubscriptionOptions);